// extracted by mini-css-extract-plugin
export default {"root":"ListStatics_root__j8FNs","item":"ListStatics_item__mTr5j"};